import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRedo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRedo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5e9c2ce4a8377dd433e107bdebb862dcf4f09a53', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1702eabc39a9ddb42e50df5c1141fc58ebb8711d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b526b1d5bc28492f556e2127b49a4d8277f83c76', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.166 7.772h4.628V5.5a.5.5 0 0 1 .853-.354L17.68 8.17a.5.5 0 0 1 0 .706l-3.032 3.052a.5.5 0 0 1-.854-.352v-2.3H9.166a3.6 3.6 0 0 0-3.662 3.358 3.32 3.32 0 0 0 .939 2.473 3.7 3.7 0 0 0 1.926 1.015.51.51 0 0 1 .425.493v.532a.51.51 0 0 1-.587.5 5 5 0 0 1-2.841-1.493 4.85 4.85 0 0 1-1.362-3.565 5.11 5.11 0 0 1 5.162-4.817", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-redo", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-redo"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-redo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRedo$1);
            }
            break;
    } });
}

const CosmosIconRedo = CosmosIconRedo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRedo, defineCustomElement };
